
export class StatusTypes {
    static readonly DRAFT = 1;
    static readonly PENDING = 2;
    static readonly APPROVED = 3;
    static readonly REJECTED = 4;
    static readonly INPROCESS = 5;
    static readonly JOINED = 6;
    static readonly WITHDRAWN = 1076;
    static readonly HOLD = 1077;
    static readonly DECLINED = 1078;
    static readonly CANCELLED = 2446;
    static readonly INVITED = 10900;
    static readonly CANCELLEDINVITE = 11047
}
export class ImmStatusType {

    static readonly DRAFT = 5920;
    static readonly PENDING = 5921;
    static readonly ACCEPTED = 5922;
    static readonly DECLINED = 5923;
    static readonly INPROCESS = 5924;
    static readonly APPROVED = 5925;
    static readonly REJECTED = 5926;
    static readonly COMPLETED = 5927;
    static readonly HOLD = 5928;
  static readonly WITHDRAWN = 12244;

}

export class EmployeeCategory {
    static readonly INTERNAL_TRANSFER = 717;
}

export class PreBoardingTypesIT {
    static readonly Diff_Offices_Expats = 1079;
    static readonly Diff_Offices_nationals_GCCnationals = 1080;
    static readonly Within_Same_Office = 982;
}

export class PreBoardingTypes {
    static readonly Expat = 1045;
    static readonly National_GCCNational = 1046;
}
export class YesNo {
    static readonly Yes = 1074;
    static readonly No = 1075;
}
export class InternalTransferPBType {
  static readonly CommonInternalTranfserPBTypeID = 13191;
}

export class CWStatusType {
    static readonly DRAFT = 16108;
    static readonly INPROCESS = 16109;
    static readonly EXTENDED = 16110;
    static readonly COMPLETED = 16111;
}
export class CWStatusTypeName{
    static readonly DRAFT = 'CWDraft';
    static readonly INPROCESS = 'CWInProcess';
    static readonly EXTENDED = 'CWExtended';
    static readonly COMPLETED = 'CWCompleted';
}